import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { reduxForm, Field, change } from 'redux-form';
import { Grid } from './../../../themes/default';
import { Section, Content, Main, Buttons, FormContent, FormActions } from './../../../components/includes/container';
import { ToolbarPrimary } from './../../../components/includes/toolbar';
import { BreadcrumbItem } from './../../../components/includes/breadcrumb';
import { Upload } from './../../../components/includes/upload';
import { Ttolbar } from './../../../components/includes/ui/table';
import { InputTextField, SelectField, OptionField } from './../../../components/includes/ui/input';
import { Btn } from './../../../components/includes/ui';
import { FeaturedService } from './../../../services';

import VALIDATION from './../../../config/validation';

const validate = values => {

  const errors = {}

  if (values.status === '-1') {
    errors.status = VALIDATION.required;
  }

  if (values.disposition === '-1') {
    errors.disposition = VALIDATION.required;
  }

  // if (values.target === '-1') {
  //   errors.target = VALIDATION.required;
  // }

  if (!values.name) {
    errors.name = VALIDATION.required;
  }else if(values.name.length > 255){
    errors.name = 'El tamaño máximo es de 255 caracteres.';
  }

  if (!values.title) {
    errors.title = VALIDATION.required;
  }else if(values.title.length > 1024){
    errors.title = 'El tamaño máximo es de 1024 caracteres.';
  }

  if (!values.paragraph) {
    errors.paragraph = VALIDATION.required;
  }else if(values.paragraph.length > 2048){
    errors.paragraph = 'El tamaño máximo es de 2048 caracteres.';
  }

  return errors

};

class FeaturedCreate extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      loading: false,
      sending: false,
      upload: false
    };
  }

  componentDidMount(){

  }

  /*
  ** @Service
  ** @Description: New
  */

  _Create = (values) => {

    FeaturedService.create(values).then((response) => {

      /**
      * @Service find all by page
      */
      this.props.history.push('/featureds');

      /**
      * @Dispatch for alert success message
      */
      this.props.AlertShow({ open: true, variant: 'success', message: `Exito, el destacado fue creado.` });

    }).catch((error) => {

      // @Dispatch alert error
      this.props.AlertShow({ open: true, variant: 'error', message: error.data.message });

    });

  }

  handleSubmitForm = (values) => {
    this._Create(values);
  }

  /*
  ** @Service
  ** @Description: Attachments
  */

  onUploadImagenLarge = (file) => {
    this.props.dispatch(change('FeaturedCreate', 'image_large', file.attachment[0] ));
  }

  onUploadImagenMedium = (file) => {
    this.props.dispatch(change('FeaturedCreate', 'image_medium', file.attachment[0] ));
  }

  onUploadImagenSmall = (file) => {
    this.props.dispatch(change('FeaturedCreate', 'image_small', file.attachment[0] ));
  }

  render() {

    const { sending } = this.state;
    const { handleSubmit, invalid } = this.props;

    return (
      <Section>
        <ToolbarPrimary title="Destacados"/>
        <BreadcrumbItem to='/featureds'>Destacados</BreadcrumbItem>
        <BreadcrumbItem to='/featureds/create'>Crear</BreadcrumbItem>
        <Content>

          <Main>

            <form noValidate autoComplete="off" onSubmit={ handleSubmit(this.handleSubmitForm) }>

              <Ttolbar title="Creación de destacado"/>

              <FormContent enabledActions>

                <Grid container spacing={24}>

                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <Field
                        name="name"
                        component={ InputTextField }
                        label="Nombre"
                        type="text"
                        required
                    />
                  </Grid>

                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <Field
                        name="status"
                        component={ SelectField }
                        label="Estado" required>
                          <OptionField key="-1" value="-1">Seleccionar...</OptionField>
                          <OptionField key="true" value="true">Activo</OptionField>
                          <OptionField key="false" value="false">Bloqueado</OptionField>
                    </Field>
                  </Grid>

                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <Field
                        name="title"
                        component={ InputTextField }
                        label="Título"
                        type="text"
                        required
                    />
                  </Grid>

                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <Field
                        name="paragraph"
                        component={ InputTextField }
                        label="Sub-Título"
                        type="text"
                        required
                    />
                  </Grid>

                  <Grid item lg={4} md={4} sm={12} xs={12}>
                    <Field
                        name="label"
                        component={ InputTextField }
                        label="Label"
                        type="text"
                    />
                  </Grid>

                  <Grid item lg={4} md={4} sm={12} xs={12}>
                    <Field
                        name="disposition"
                        component={ SelectField }
                        label="Disposición" required>
                          <OptionField key="-1" value="-1">Seleccionar...</OptionField>
                          <OptionField key="left" value="left">Left</OptionField>
                          <OptionField key="right" value="right">Right</OptionField>
                          <OptionField key="fluid" value="fluid">Fluid</OptionField>
                    </Field>
                  </Grid>

                  <Grid item lg={4} md={4} sm={12} xs={12}>
                    <Field
                        name="position"
                        component={ InputTextField }
                        label="Posición"
                        type="number"
                        required
                    />
                  </Grid>

                  <Grid item lg={4} md={4} sm={4} xs={12}>
                    <Field
                        name="link_primary_name"
                        component={ InputTextField }
                        label="Nombre (Botón principal)"
                        type="text"
                    />
                  </Grid>

                  <Grid item lg={4} md={4} sm={4} xs={12}>
                    <Field
                        name="link_primary_url"
                        component={ InputTextField }
                        label="Enlace (Botón principal)"
                        type="text"
                    />
                  </Grid>

                  <Grid item lg={4} md={4} sm={4} xs={12}>
                    <Field
                        name="link_primary_target"
                        component={ SelectField }
                        label="Apertura (Botón principal)">
                          <OptionField key="_self" value="_self">Misma Página</OptionField>
                          <OptionField key="_blank" value="_blank">Nueva Página</OptionField>
                    </Field>
                  </Grid>

                  <Grid item lg={4} md={4} sm={4} xs={12}>
                    <Field
                        name="link_secondary_name"
                        component={ InputTextField }
                        label="Nombre (Botón secundario)"
                        type="text"
                    />
                  </Grid>

                  <Grid item lg={4} md={4} sm={4} xs={12}>
                    <Field
                        name="link_secondary_url"
                        component={ InputTextField }
                        label="Enlace (Botón secundario)"
                        type="text"
                    />
                  </Grid>

                  <Grid item lg={4} md={4} sm={4} xs={12}>
                    <Field
                        name="link_secondary_target"
                        component={ SelectField }
                        label="Apertura (Botón principal)">
                          <OptionField key="_self" value="_self">Misma Página</OptionField>
                          <OptionField key="_blank" value="_blank">Nueva Página</OptionField>
                    </Field>
                  </Grid>

                  <Grid item lg={4} md={4} sm={4} xs={12}>
                    <Field
                        name="image_large"
                        type="hidden"
                        component={ InputTextField }
                    />
                    <Upload
                      button="Subir imagen (Large)"
                      onSuccess={ this.onUploadImagenLarge.bind(this) }
                    />
                  </Grid>

                  <Grid item lg={4} md={4} sm={4} xs={12}>
                    <Field
                        name="image_medium"
                        type="hidden"
                        component={ InputTextField }
                    />
                    <Upload
                      button="Subir imagen (Medium)"
                      onSuccess={ this.onUploadImagenMedium.bind(this) }
                    />
                  </Grid>

                  <Grid item lg={4} md={4} sm={4} xs={12}>
                    <Field
                        name="image_small"
                        type="hidden"
                        component={ InputTextField }
                    />
                    <Upload
                      button="Subir imagen (Small)"
                      onSuccess={ this.onUploadImagenSmall.bind(this) }
                    />
                  </Grid>

                </Grid>

              </FormContent>

              <FormActions>
                <Grid container>
                  <Grid item lg={6} md={6} sm={6} xs={6}>
                    <Buttons>
                      <Btn aria-label="Volver" icon="back" color="secondary" component={ NavLink } to="/featureds">
                        Volver
                      </Btn>
                    </Buttons>
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={6}>
                    <Buttons align="right">
                      <Btn aria-label="Guardar página" icon="add" color="success" type="submit" disabled={ invalid } loading={ sending }>
                        Guardar destacado
                      </Btn>
                    </Buttons>
                  </Grid>
                </Grid>
              </FormActions>

            </form>

          </Main>

        </Content>
      </Section>
    )
  }
}

FeaturedCreate = reduxForm({
  form: 'FeaturedCreate',
  validate,
  initialValues: {
    status: '-1',
    link_primary_target: '_self',
    link_secondary_target: '_self',
    disposition: '-1',
    position: '1'
  }
})(FeaturedCreate);

const mapStateToProps = (state) => {
  return {
    Alert: state.Alert
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    AlertShow: (data) => {
      dispatch({
        type: 'ALERT_SHOW',
        data: data
      });
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FeaturedCreate);
